/* eslint-disable no-shadow */
import { SetYear } from "@/stores/actions/YearPicker";

const state = { year: new Date().getFullYear() };

const actions = {
	[SetYear]: ({ commit }, year) =>
	{
		commit(SetYear, year);
	},
};
const mutations = {
	[SetYear]: (state, year) =>
	{
		state.year = year;
	},
};

export default {
	state,
	actions,
	mutations,
};
